export default "__VITE_ASSET__$cgdlCQ4__"